// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Domain from '../components/Domain';

import type {RootState} from '../../../modules';
import {actions as GeneralAction} from '../../configure/general/duck';
import {actions as AuthAction} from '../../auth/duck';
import {actions as OnBoardingAction} from '../../on-boarding/duck';
import {actions as CurrencyAction} from '../../currency/duck';
import {actions as CountryAction} from '../../country/duck';
import {actions as UiAction} from '../../ui/duck';
import {actions as CustomDomainAction} from '../../customDomain/duck';

import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    user: state.auth.user,
    validationResult: state.onBoarding.validationResult,
    isValidating: state.onBoarding.isValidating,
    domainChangeToken: state.auth.domainChangeToken,
    isValidatingSsl: state.customDomain.isValidatingSsl,
    sslIsValid: state.customDomain.sslIsValid,
    errorValidatingSsl: state.customDomain.errorValidating,
    startGeneratingSsl: state.customDomain.startGeneratingSsl,
    isGeneratingSsl: state.customDomain.isGeneratingSsl,
    customDomain: state.customDomain.customDomain,
    domainDeleted: state.customDomain.domainDeleted,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...GeneralAction,
        ...AuthAction,
        ...OnBoardingAction,
        ...CurrencyAction,
        ...CountryAction,
        ...UiAction,
        ...CustomDomainAction,
      },
      dispatch
    )
)(Domain);
